/**
 * Utilidades de navegación para manejar el flujo entre
 * la web del colegio (colegiotslomas.org) y el Portal de Servicios
 */

// URL de la web principal del colegio
const COLEGIO_WEB_URL = 'https://www.colegiotslomas.org';

/**
 * Navega hacia atrás en el historial.
 * Si no hay historial previo, redirige a la web del colegio.
 * 
 * @param {string} fallbackUrl - URL alternativa si no hay historial (default: web del colegio)
 */
export const goBack = (fallbackUrl = COLEGIO_WEB_URL) => {
  // Verificar si hay historial previo
  // history.length > 1 no es 100% confiable, pero es un buen indicador
  // También verificamos el referrer
  const hasHistory = window.history.length > 1;
  const hasReferrer = document.referrer && document.referrer.length > 0;
  
  if (hasHistory || hasReferrer) {
    window.history.back();
    
    // Fallback: si después de 100ms seguimos en la misma página, 
    // significa que history.back() no funcionó
    const currentUrl = window.location.href;
    setTimeout(() => {
      if (window.location.href === currentUrl) {
        window.location.href = fallbackUrl;
      }
    }, 150);
  } else {
    // No hay historial, ir al fallback
    window.location.href = fallbackUrl;
  }
};

/**
 * Navega hacia atrás, con fallback a una ruta interna del portal
 * 
 * @param {string} fallbackPath - Ruta interna como fallback (ej: '/servicios', '/beneficios')
 */
export const goBackInternal = (fallbackPath = '/') => {
  const hasHistory = window.history.length > 1;
  
  if (hasHistory) {
    window.history.back();
    
    const currentUrl = window.location.href;
    setTimeout(() => {
      if (window.location.href === currentUrl) {
        window.location.href = fallbackPath;
      }
    }, 150);
  } else {
    window.location.href = fallbackPath;
  }
};

/**
 * Constante exportada para uso directo en links
 */
export const COLEGIO_URL = COLEGIO_WEB_URL;
